<template>
  <div class="grid-col-span-3">
    <img src="../assets/images/image-about-light.jpg" alt="" />
  </div>
</template>
<script setup></script>
<style></style>
